"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DELAY = exports.COOKIE = void 0;
exports.COOKIE = {
    SURVEY_DISMISSED: "_bh_hs",
};
/** 60 sec default delay time before showing prompt - mobile only */
exports.DEFAULT_DELAY = 60000;
//# sourceMappingURL=constants.js.map